/*@flow*/
import type { GoogleButton } from '../types';
import qs from 'qs';

export default (config: $Diff<GoogleButton, { id: ID }>): string => {
  const { url, fields } = config;
  const s = url && url.match(/\?(.+)/);
  if (s && s[1]) {
    const params = qs.parse(s[1]);
    const entries: Object => [string, any][] = (Object.entries: any);
    const flippedEntryKeys = entries(params)
      .filter(arr => arr[0].match('entry.'))
      .map<[string, string]>(arr => [arr[1], arr[0]])
      .reduce((s2, v) => ({ ...s2, [v[0]]: v[1] }), {});

    fields.forEach(key => {
      const entry = flippedEntryKeys[key];
      if (entry) {
        params[entry] = `__${key}__`;
      }
    });

    const base = url.slice(0, url.indexOf('?'));
    const slug = qs.stringify(params);
    return `${base}?${slug}`;
  }
  return '';
};
